/**
 * External dependencies
 */
import $ from 'jquery';

if ( 'undefined' !== typeof isThewayforward ) {
	$( document ).ready( () => {
		var hideQuestionnaires = [ '#gf-form-2-section', '#gf-form-3-section', '#gf-form-1-section' ];
		for ( var i in hideQuestionnaires ) {
			$( hideQuestionnaires[i] ).css( 'display', 'none' );
		}

		var assessmentOptions = $( '#start-assessment-options-section' );
		var assessmentNumbers = $( '#start-assessment-numbers-section' );
		if ( '#assessment-options' === location.hash.trim() ) {
			// assessmentNumbers.css( 'display', 'none' );
		} else {
			assessmentOptions.css( 'display', 'none' );
		}

		$( '.start-assessment-btn .elementor-button-wrapper > .elementor-button' ).click( function( e ) {
			e.preventDefault();

			assessmentOptions.css( 'display', 'block' );
			//assessmentNumbers.css( 'display', 'none' );
			setTimeout( function() {
				location.hash = 'assessment-options';
			}, 500 );
		} );

		$( '.assessment-options-btn' ).click( function() {
			var hideArray = [ $( '#start-assessment-btn-section' ), assessmentNumbers, assessmentOptions ];
			for ( var i in hideArray ) {
				hideArray[i].css( 'display', 'none' );
			}
			var elem = $( this );
			var section = $( '#' + elem.attr( 'id' ) + '-section' );
			section.css( 'display', 'block' );
			$( 'html,body' ).animate( { scrollTop: section.offset().top - 60 }, 500 );
			$( '.start-assessment-btn' ).hide();
		} );

		$( '#assessment-result-share-btn' ).click( function() {
			const sanitizedUrl = encodeURIComponent( window.location.href ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
			window.open( 'mailto:?subject=Here is my result from \'The Way Forward\' assessment&body=' + sanitizedUrl );
		} );
		$( '#assessment-result-start-again-btn' ).click( function() {
			window.open( isThewayforward.startAssessmentUrl, '_blank' );
		} );

		if ( 'undefined' !== typeof coxThewayforwardGfObj ) {
			var assessmentName = $( '#assessment-result-banner-heading h2' );
			var assessmentNameSubheading = $( '#assessment-result-banner-subheading h2' );
			var assessmentCategoryNews = $( '#assessment-result-category-news-text h2' );
			var assessmentCategoryHeading = $( '#assessment-result-category-header h2' );
			var assessmentCategoryText = $( '#assessment-result-category-text p' );
			var assessmentImage = $( '#assessment-result-icon .elementor-image' );
			var uberflipContents = $( '#uberflip-contents-element .elementor-widget-container' );

			// phpcs:disable WordPressVIPMinimum.JS.HTMLExecutingFunctions.html
			assessmentName.html( coxThewayforwardGfObj.headingText );
			assessmentNameSubheading.html( coxThewayforwardGfObj.subHeadingText );
			assessmentCategoryHeading.html( coxThewayforwardGfObj.categoryHeading );
			assessmentCategoryNews.html( coxThewayforwardGfObj.categoryNewsText );
			assessmentImage.html( coxThewayforwardGfObj.categoryImage );
			assessmentCategoryText.html( coxThewayforwardGfObj.categoryText );
			uberflipContents.html( coxThewayforwardGfObj.uberflipContent );
			// phpcs:enable WordPressVIPMinimum.JS.HTMLExecutingFunctions.html
		}
	} );
}
